module.exports = __webpack_public_path__ + "static/media/flask.cbf8a990.svg";